import { computed, getCurrentInstance } from 'vue';

export interface Borders {
    top?: boolean,
    bottom?: boolean,
    left?: boolean,
    right?: boolean,
}

// vllt hilft das https://vuejs.org/api/sfc-script-setup.html#reactive-props-destructure
export interface BordersProps {
    borders?: Borders,
    noBorders?: boolean,
    focusBorders?: Borders,
    noFocusBorders?: boolean,
}

/**
 * @deprecated
 */
export const bordersProps = {
    borders: {
        type: [Object],
        default: null,
    },
    noBorders: {
        type: [Boolean],
        default: false,
    },
    focusBorders: {
        type: [Object],
        default: null,
    },
    noFocusBorders: {
        type: [Boolean],
        default: false,
    },
};

export function getBordersComposable() {
    const { props } = getCurrentInstance() as { props: BordersProps };

    const bordersConfig = computed<Borders>(() => {
        if (props.noBorders) {
            return {
                top: false,
                bottom: false,
                left: false,
                right: false,
            };
        }

        return {
            top: true,
            bottom: true,
            left: true,
            right: true,
            ...props.borders,
        };
    });
    const focusBordersConfig = computed<Borders>(() => {
        if (props.noFocusBorders) {
            return {
                top: false,
                bottom: false,
                left: false,
                right: false,
            };
        }
        return {
            top: true,
            bottom: true,
            left: true,
            right: true,
            ...props.focusBorders,
        };
    });

    return {
        bordersConfig,
        focusBordersConfig,
    };
}
